export const VALIDATION_DEBOUNCE_TIME = 1000
export const IS_TYPING_DEBOUNCE_TIME = 5000
export const SENDING_MESSAGE_MAX_TIMEOUT = 5000
